document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('.wt-header__sticky-menu-trigger_lavit');
  const closeBtn = document.querySelector('.wt-nav-close-icon');
  if (openBtn) {
    openBtn.addEventListener('click', function () {
      document.body.classList.toggle('no-focus-visible');
      document.body.classList.toggle('menu-open');
      document.body.classList.toggle('menu-drawer-overlay-on');
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.body.classList.remove('no-focus-visible');
      document.body.classList.remove('menu-open');
      document.body.classList.remove('menu-drawer-overlay-on');
    });
  }
});
